import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PeriodosSaldosService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }

  public postPeriodo(periodos): Observable<any>{
    const per = {
      periodos: periodos,
    } 
    const body = JSON.stringify(per);
    const apiURL = this.apiURL + 'api/CreatePeriodos';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public getPeriodosAll(): Observable<any>{
    const apiURL = this.apiURL + 'api/ListPeriodos';
    return this.http.post(`${apiURL}`, { headers: this.headers});
  }
  public getPeriodosAnio(anio:number): Observable<any>{
    const an = {
      anio: anio,
    } 
    const body = JSON.stringify(an);
    const apiURL = this.apiURL + 'api/ListPeriodos';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  
  public getPeriodosAgrupAnio(): Observable<any>{
    const apiURL = this.apiURL + 'api/ListPeriodosPorAnio';
    return this.http.post(`${apiURL}`, { headers: this.headers});
  }

  // SERVICIOS PARA SALDOS 
  public getPeriodosTemplate(templateid:number): Observable<any>{
    const an = {
      templateid: templateid,
    } 
    const body = JSON.stringify(an);
    const apiURL = this.apiURL + 'api/saldos/periodos/template';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public getPeriodosSucursal(idIns:number, idSuc:number): Observable<any>{
    const an = {
      institutionid: idIns,
      sucursalid: idSuc,
    } 
    const body = JSON.stringify(an);
    const apiURL = this.apiURL + 'api/saldos/periodos';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public getSaldosPeriodo(idIns:number, idSuc:number, anio:number, mes:number): Observable<any>{
    const an = {
      institutionid: idIns,
      sucursalid: idSuc,
      anio: anio,
      mes: mes
    } 
    const body = JSON.stringify(an);
    const apiURL = this.apiURL + 'api/saldos/aniomes';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public getSaldosAll(idIns:number, idSuc:number): Observable<any>{
    const an = {
      institutionid: idIns,
      sucursalid: idSuc,
    } 
    const body = JSON.stringify(an);
    const apiURL = this.apiURL + 'api/saldos/all';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }
  public postSaldosPeriodo(instId:number, sucId:number, anio:number, mes:number, saldos): Observable<any>{
    const d = {
      institutionid: instId,
      sucursalid: sucId,
      anio: anio,
      mes: mes,
      saldos: saldos,
    }
    const body = JSON.stringify(d);
    const apiURL = this.apiURL + 'api/saldos/Createsaldos';
    return this.http.post(`${apiURL}`, body, { headers: this.headers});
  }

}
